export class RoleUser {
  label: string;
  cognitoUsername: string;
  preferredUsername: string;
  imageUrl: string;
  email: string;

  constructor(data: any) {
    this.label = data.label || '';
    this.cognitoUsername = data.cognito_username || '';
    this.preferredUsername = data.preferred_username || '';
    this.imageUrl = data.image_url || '';
    this.email = data.email || '';
  }
}
